import _ from "lodash";
import moment from "moment";
import { LOCALE_CODES } from "../../../app/appConstants";

const formatTradingHoursToLocalTimeList = (tradingHours) => {
    let result = [];
    const tradingHoursIntervalsLength = Math.floor(tradingHours.length / 2);

    for (let i = 0; i < tradingHoursIntervalsLength; i++) {
        const startDateMoment = moment(tradingHours[i * 2].weekDayIso);
        const startTime = startDateMoment.format("HH:mm");
        const startWeekDay = startDateMoment.format("dddd");

        const endDateMoment = moment(tradingHours[i * 2 + 1].weekDayIso);
        let endTime = endDateMoment.format("HH:mm");
        const endWeekDay = endDateMoment.format("dddd");

        if (startWeekDay !== endWeekDay && endTime !== '00:00') {
            result.push({ weekDay: startWeekDay, startTime, endTime: '23:59' });
            result.push({ weekDay: endWeekDay, startTime: '00:00', endTime });
        } else {
            if (endTime === '00:00') {
                endTime = '23:59'
            }
            result.push({ weekDay: startWeekDay, startTime, endTime })
        }
    }
    return result;
}

const groupLocalTimeListByWeekDay = (localTimesList) => {
    const weekDays = {};

    for (let i = 0; i < localTimesList.length; i++) {
        const item = localTimesList[i];
        if (weekDays[item.weekDay]) {
            weekDays[item.weekDay].intervals.push({ startTime: localTimesList[i].startTime, endTime: localTimesList[i].endTime })
        } else {
            weekDays[item.weekDay] = {
                intervals: [{ startTime: localTimesList[i].startTime, endTime: localTimesList[i].endTime, }],
                order: i,
                weekDay: item.weekDay
            };
        }
    }
    return _.sortBy(Object.values(weekDays), 'order').map(weekDay => {
        const intervals = _.sortBy(weekDay.intervals, 'startTime');
        for (let i = 0; i < intervals.length - 1; i++) {
            // merge 00:00 - 04:00, 04:00 - 23:59 --> 00:00 - 23:59
            if (intervals[i].endTime === intervals[i + 1].startTime) {
                intervals.splice(i, 1, {...intervals[i], endTime: intervals[i + 1].endTime});
                intervals.splice(i + 1, 1);
            }
        }
        return {...weekDay, intervals}
    });
}

export const formatAssetInfoTradingHours = (tradingHours = [], currentLocale = moment.locale()) => {
    // to parse dx trading hours days we switch to en locale first
    moment.locale(LOCALE_CODES.en);
    const currentTradingHours = tradingHours.map((tradingHour) => ({
        ...tradingHour,
        weekDayIso: moment(tradingHour.weekDay, "dddd, HH:mm:ssZ").toISOString(),
    }));
    moment.locale(currentLocale);

    const localTimeList = formatTradingHoursToLocalTimeList(currentTradingHours);
    return groupLocalTimeListByWeekDay(localTimeList);
}
